import React, { Component } from 'react'
import { bindActionCreators, compose } from 'redux'

import { connect } from 'react-redux'
import { openModal, ModalContent } from 'redux/slices/globalModal'
import styles from './styles'
import { withStyles } from '@material-ui/styles'

class ErrorBoundary extends Component {
    constructor(props) {
        super(props)
        this.retries = 0
        this.state = { hasError: false }
    }

    static getDerivedStateFromError() {
        return { hasError: true }
    }

    componentDidCatch(error) {
        console.error(`Error caught in error ${this.props.name || 'app'} boundary:`, error.message)

        if (this.props.showModal) {
            this.props.openModal({
                content: ModalContent.ERROR,
                canClose: false,
            })
        }

        const nextRetryIn = 1000 * 3 ** this.retries++

        this.timeoutId = setTimeout(this.retry, nextRetryIn)
    }

    componentWillUnmount() {
        clearTimeout(this.timeoutId)
    }

    retry = () => this.setState({ hasError: false })

    render() {
        if (this.state.hasError) {
            return <div className={this.props.classes.wrapper} />
        }

        return this.props.children
    }
}

const mapDispatchToProps = dispatch =>
    bindActionCreators(
        {
            openModal,
        },
        dispatch,
    )

export default compose(connect(null, mapDispatchToProps), withStyles(styles))(ErrorBoundary)
